import * as React from 'react';
import cx from 'classnames';

// Hooks
import { useResponsiveLayout } from '@shopee-user/layout-responsive';

// Constants
import { Layout } from '@shopee-user/layout-responsive';
import { ResponsiveImageUseCase } from '@shopee-user/business-customization-types';

// Components
import ResponsiveImage from '../ResponsiveImage';

import styles from './style.scss';
export interface ResponsiveBackgroundContainerProps {
  /**
   * Allows customizing the width / height of background image
   */
  backgroundContainerClassName?: string;
  className?: string;
  children: React.ReactNode;
  imageUrl: string;
  imageUrlSet: string;
}

export default function ResponsiveBackgroundContainer({
  backgroundContainerClassName,
  className,
  children,
  imageUrl,
  imageUrlSet,
}: ResponsiveBackgroundContainerProps): JSX.Element {
  const { layout } = useResponsiveLayout();

  return (
    <div
      className={cx(styles.backgroundContainer, backgroundContainerClassName)}
    >
      {/* 1. Only show on desktop, if not, there will be a small square where the image is on older mobile devices.
       * 2. Only show if imageUrl is defined. If not, there will be a broken image on older browsers when imageUrl is not defined. */}
      {layout === Layout.Desktop && !!imageUrl && (
        <ResponsiveImage
          usecase={ResponsiveImageUseCase.AuthBackground}
          className={styles.backgroundImage}
          defaultSrc={imageUrl}
          srcSet={imageUrlSet}
        />
      )}
      <div className={cx(className, styles.container)}>{children}</div>
    </div>
  );
}
